import { useState, type PropsWithChildren } from 'react';

import styles from './CollapsibleUnit.module.css';

interface CollapsibleUnitProps extends PropsWithChildren {
  editMode?: boolean;
  summaryLabel: string;
}

export function CollapsibleUnit({
  children,
  editMode = false,
  summaryLabel,
}: CollapsibleUnitProps) {
  const [isOpen, setIsOpen] = useState(false);
  const showCollapsedEditState = editMode && !isOpen;

  return (
    <details
      className={styles.details}
      data-collapsible-unit="true"
      data-edit-mode={editMode ? 'true' : 'false'}
      onToggle={(event) => {
        setIsOpen(event.currentTarget.open);
      }}
      open={isOpen}
    >
      <summary
        className={styles.summary}
        onClick={(event) => {
          event.preventDefault();
          setIsOpen((currentValue) => !currentValue);
        }}
      >
        <span>{summaryLabel}</span>
        {showCollapsedEditState ? (
          <span className={styles.expandToEdit}>Expand to edit</span>
        ) : null}
      </summary>
      <div className={styles.body} hidden={!isOpen}>{children}</div>
    </details>
  );
}
